import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Button, CircularProgress, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import AlertDialog from 'elements/AlertDialog';

const LangList = () => {

  const [loading, setLoading] = useState(false); 
  const [lang_list, setLangList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const currentPage = parseInt(localStorage.getItem('lang_page') || "1");

  const [page, setPage] = useState(currentPage);
  const [refreshList, setRefreshList] = useState(0);


  /*=========================================================
  LOAD LIST            
  =========================================================*/

  useEffect(() => {
    
      axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'lang_list',
          page: page,
        }
      })
        .then((response) => {
          console.log("lang_list ", response.data); 
          setLangList(response.data.lang_list)
          setTotalPages(response.data.total_pages)
          setLoading(true)
           
        })
        .catch((err) => {
          console.log(err.data);
        })
        localStorage.setItem('lang_page', page.toString())
    
  }, [page, refreshList])
  /*=========================================================*/



  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (lang_id: number) => {
    setActiveItem(lang_id)
    setOpenAlert(true)
  }

  const deleteItem = () => {
    axios.post(ProjectConfig.api_url, null, 
      {
        params: {
          request: 'delete_lang',
          lang_id: activeItem,
        }
      })
  
      .then((response) => {
        console.log(response.data);
        setRefreshList(refreshList + 1)
        
      })
      .catch((err) => {
        console.log(err.data);
      })
      .then(() => {
        setOpenAlert(false)
      })
  }

  
  /*=========================================================*/

  const [openAlert, setOpenAlert] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  
  return (
    <div id='LangList'>
      
      <div className='buttons_top'>
        <Button component={Link} to="add" variant="contained">
          Nuevo idioma
        </Button>

      </div>
        <div id="task_list_container" className="flex_container">
          
            <Box id='lang_list' title="Idiomas" subtitle="Lista">
            {!loading && <div id='loader'><CircularProgress /></div>}
            <TableContainer>
            <Table stickyHeader aria-label="sticky table"> 
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Idioma</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                  {lang_list.map((lang, i) => (
                    <TableRow 
                      key={i}
                      hover
                      role="checkbox"
                    >
                      <TableCell onClick={() => { window.location.href = `idiomas/edit/${lang.lang_id}` }}>
                        {lang.lang_id}
                      </TableCell>

                      <TableCell onClick={() => { window.location.href = `idiomas/edit/${lang.lang_id}` }}>
                        {lang.lang}
                      </TableCell>

                      <TableCell> 
                        <IconButton aria-label="delete" color="primary" onClick={() => handleDelete(lang.lang_id)}>
                          <DeleteOutlineOutlinedIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          <Pagination 
            count={total_pages} 
            page={page}  
            onChange={(event, value) => {
              setPage(value)
            }} 
            color="primary"
            style={{"marginTop": "20px", "alignSelf": "center"}}
          />
          </Box>
 
        </div>

        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar este idioma?"
            send={deleteItem}
        />
    </div>
  );
};

export default LangList;
